var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInboxOn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inbox_Active",
    "data-name": "Inbox Active",
    transform: "translate(-282 -25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 35,
    height: 35,
    transform: "translate(282 25)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40843",
    "data-name": "Path 40843",
    d: "M1069.344,4715.572H1045.66a2.612,2.612,0,0,1-.456-.039,2.411,2.411,0,0,1-2.2-2.392V4697.4a2.4,2.4,0,0,1,2.4-2.4h24.2a2.4,2.4,0,0,1,2.4,2.4v15.741a2.415,2.415,0,0,1-2.2,2.392A2.744,2.744,0,0,1,1069.344,4715.572Zm-7.8-9.187h0l7.293,7.6a2.149,2.149,0,0,0,1.323-.9l-7.709-7.56,7.839-7.854a2.109,2.109,0,0,0-1.059-.994l-.335.337-.9.9c-6.116,6.137-9.306,9.335-9.482,9.506a1.332,1.332,0,0,1-1.045.492,1.374,1.374,0,0,1-1-.493c-.148-.14-3.767-3.749-10.755-10.724a2.113,2.113,0,0,0-1.009.964l7.852,7.864-7.722,7.567a2.145,2.145,0,0,0,1.264.877l7.372-7.592.01.007c.117.108.512.483,1.646,1.621a3.062,3.062,0,0,0,2.346,1.178,3.147,3.147,0,0,0,2.48-1.178c.994-1.028,1.586-1.623,1.591-1.627Z",
    transform: "translate(-758 -4662.8)",
    fill: "#da291c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInboxOn);
export default __webpack_public_path__ + "static/media/icon_inbox_on.ec2c8d70afbd8c6e489cd1d62697e8d1.svg";
export { ForwardRef as ReactComponent };